import React from "react-router-dom";
import LazyLoad from "react-lazyload";

import './IMXItem.scss'
import {Fade, IconButton, Tooltip} from "@material-ui/core";
import CustomButton from "../../generics/CustomButton/CustomButton";
import ArrowUpLeft from "../../resources/svg/arrow-up-left";

export default function IXMItem({
                                    key,
                                    item: { name, image_url, collection },
                                    showSellModal = null,
                                    showTransferModal = null,
                                    processing = false,
                                    userOwner = false,
                                    hideButtons = false,
                                    itemOnSale=false,
                                    handlerCanselItemFromListing,
                                    orderId
                                }) {
    console.log(orderId)

    return (
        <LazyLoad key={key} height={'400px'} once>
            <div className={'imx-item-wrapper'}>
                <div className={'imx-image-wrapper'}>
                    <img src={image_url} alt=""/>
                </div>
                <div className={ `item-description ${hideButtons ? 'block-center' : ''}` }>
                    <p className={'collection'}>{ collection.name }</p>
                    <p>{name}</p>

                    {!hideButtons && itemOnSale &&
                        <div className={'sell-action'}>

                            <CustomButton
                                text={'CANSEL'}
                                onClick={() => handlerCanselItemFromListing(String(orderId   )) }
                            />

                        </div>
                    }

                    { !hideButtons && !!showSellModal &&
                        <div className={'sell-action'}>

                            <CustomButton
                                text={'SELL'}
                                onClick={ showSellModal }
                            />

                            <Tooltip
                                TransitionComponent={Fade}
                                TransitionProps={{ timeout: 600 }}
                                title={ <p>Transfer</p> }
                            >
                                <IconButton
                                    aria-label="transfer"
                                    className="transfer-icon"
                                    onClick={showTransferModal}
                                >
                                    <ArrowUpLeft />
                                </IconButton>
                            </Tooltip>
                        </div>
                    }
                </div>
            </div>
        </LazyLoad>
    )
}